import { Button } from "@mui/material";

function Agendar() {
    return(
        <div className="agendarContainer">
            <div className="agendarContent from-bottom">
                <div className="title" style={{color:'#fff'}}>Agende uma avaliação</div>
                <div className="titleLine"/>
                <a href='https://wa.me/+554532252800' style={{textDecoration:'none', color:'#000', marginInline:'3px'}}>
                    <Button sx={{marginTop:'35px', paddingInline:'25px', height:45, borderRadius:'5px', color:'#fff', fontSize:'15px', fontWeight:'bold', backgroundColor:'#B08E44', textTransform: 'none','&:hover': {color: '#B08E44', backgroundColor:'#fff'}}}>Agendar Avaliação</Button>
                </a>
            </div>
        </div>
    )
}
export default Agendar;